






















































































































import { Popup, Form, Field, Button,Stepper } from "vant";
import PopupHeader from "@/views/h5-page/account/Component/PopupHeader.vue";

export default {
  name: "GroupDetail",
  components: {
    PopupHeader,
    [Popup.name]: Popup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
	[Stepper.name]: Stepper
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    groupList: {
      type: Array
    },
    title:{
      type:String
    }
  },
  computed: {
    enable(): boolean {
      const password = (this as any).password;
      return password !== null && password.length > 0;
    }
  },
  data() {
    return {
      active: 0,
      list: [],
      loading: false,
      finished: true,
	  setingShow:false
    };
  },
  watch:{
	  show(val){
		  if(val){
			let _this:any = (this as any)
			 _this.setingShow = false; 
			 
		  }
	  }
  },
  methods: {
    close() {
	   let _this:any = (this as any)
	  _this.setingShow = false;
	  _this.$emit("close");
    },
    success() {
      (this as any).$emit("success");
    },
	handMultiple(e,data){
		(this as any).setingShow = true
		
	},
	handSetting(){
		
		let _this:any = (this as any)
		let array:any = [];
		_this.groupList.forEach(item =>{
			array.push({futures_login_id:item.futures_login_id,multiple:item.multiple})
		})
		_this.$nextTick(() =>{
			_this.$apis.setAccountMultipleSet({info:array}).then(res =>{
				_this.$toast.success("操作成功");
				_this.setingShow = false;
				_this.$emit("setSuccess");
				_this.$emit("close");
			}).catch((e) =>{
				// _this.$toast.success("操作失败，请重试");
			})
		})
		
		// 
		
		
		
	}
  }
};
